<template>
    <base-modal
        @close="onCloseModal"
        class="poi-modal poi-modal-compose"
        :mainModalStyle="mainModalStyle"
        :modalWidth="modalWidth"
    >
        <template v-slot:modalBody>
            <div v-if="isLoading" class="poi-modal__preloader">
                <BasePreloaderGifV2 :size="60" />
            </div>
            <template v-if="!isLoading">
                <CheckDataFromFileStepOne
                    v-if="step === 1"
                    :columns="columns"
                    :table-data="tableData"
                    :file="file"
                    :file-composing-type="fileComposingType"
                    @onCloseModal="onCloseModal"
                    @onComposeFileData="onComposeFile"
                />

                <CheckDataFromFileStepTwo
                    v-if="step === 2"
                    :successPoints="successPoints"
                    :errorPoints="errorPoints"
                    :file="file"
                    :file-composing-type="fileComposingType"
                    @onCloseModal="onCloseModal"
                    @addPoints="onBatchPoiItems"
                    @onEditItem="onEditItem"
                    @onSearchItem="onSearchItem"
                    @onRemoveItem="onRemoveItem"
                    @onMoveItem="onMoveItem"
                />
            </template>
        </template>
    </base-modal>
</template>

<script>
import BaseModal from "@/components/Base/BaseModal";
import CheckDataFromFileStepOne from "./CheckDataFromFileStepOne";
import ServicePoi from "@/services/ServicesPoi/ServicePoi";
import CheckDataFromFileStepTwo from "./CheckDataFromFileStepTwo";
import BasePreloaderGifV2 from "../../../Base/BasePreloaderGifV2.vue";
export default {
    components: {
        BaseModal,
        CheckDataFromFileStepOne,
        CheckDataFromFileStepTwo,
        BasePreloaderGifV2
    },

    props: {
        columns: {
            type: Array,
            default: () => [],
        },
        tableData: {
            type: Array,
            default: () => [],
        },
        file: {
            type: File,
            default: () => {},
        },
        fileData: {
            type: Object,
            default: () => {},
        },
        fileComposingType: {
            type: String,
            default: "",
        },
    },

    data() {
        return {
            step: 1,
            successPoints: [],
            errorPoints: [],
            isLoading: false,
            mainModalStyle: {'align-items': 'center'},
            actionBuffer: []
        };
    },

    mounted() {

    },

    computed: {
        modalWidth() {
            return this.step === 1 ? '520px' : '1070px';
        }
    },

    methods: {
        onCloseModal() {
            this.$emit("onCloseModal");
        },

        onComposeFile(composeData) {
            this.isLoading = true;

            ServicePoi.composeFile({...composeData, uniq_id: this.fileData?.uniq_id}, ({
                                                                                           error: errorPoints = [],
                                                                                           success: successPoints = []
                                                                                       }) => {
                this.successPoints = successPoints;
                this.errorPoints = errorPoints;
                this.step = 2;
                this.isLoading = false
            })
        },

        async onBatchPoiItems() {
            const isConfirm = await this.$confirm("Создатутся только найденные точки, вы уверены что хотите продолжить?");

            // if (this.errorPoints.length > 0 && !confirm("Создатутся только найденные точки, вы уверены что хотите продолжить?")) {
            if (this.errorPoints.length > 0 && !isConfirm) {
                return;
            }

            this.$emit("onBatchPoiItems", this.successPoints);
        },

        onEditItem(row, attribute, value) {
            const itemIndex = this.errorPoints.findIndex(point => row.num === point.num)

            if (itemIndex === -1) {
                return;
            }

            let errorPoints = [...this.errorPoints];
            errorPoints[itemIndex] = {...errorPoints[itemIndex], [attribute]: value}
            this.errorPoints = [...errorPoints]
        },

        onRemoveItem(num) {
            this.errorPoints = [...this.errorPoints.filter(point => point.num !== num)]
        },

        onMoveItem(item) {
            const {num = null} = item
            this.errorPoints.push(item)

            this.successPoints = [...this.successPoints.filter(point => point.num !== num)]
        },

        onAddItem(item) {
            this.successPoints.push(item);

            this.onRemoveItem(item.num)

            this.sendSuccessNotification()
        },

        onSearchItem(row) {
            const {num = null} = row

            if(this.isActionInBuffer("search", num)){
                return;
            }

            this.setActionBuffer("search", num);

            if (this.fileComposingType === "coords") {
                this.searchItemByCoords(row)
            }

            if (this.fileComposingType === "address") {
                this.searchItemByAddress(row)
            }
        },

        searchItemByCoords(row) {
            const {lat = 0, lng = 0, num = null} = row

            ServicePoi.findAddressByCoordsWithCity(
                lat, lng,
                (result) => {
                    const {lat = "", lng = "", address = "", city_name: city = ""} = result;

                    this.onAddItem({...row, lat, lng, city_name: city, address})
                    this.unsetActionBuffer("search", num);
                },
                () => {
                    this.sendErrorNotification()
                    this.unsetActionBuffer("search", num);
                }
            )
        },

        searchItemByAddress(row) {
            const {city_name: city = "", address = "", num = null} = row

            ServicePoi.findCoordsByAddressWithCity(
                `${city} ${address}`,
                (result) => {
                    const {lat = "", lng = "", city_name: city = ""} = result;

                    this.onAddItem({...row, lat, lng, city_name: city})
                    this.unsetActionBuffer("search", num);
                },
                () => {
                    this.sendErrorNotification()
                    this.unsetActionBuffer("search", num);
                }
            )
        },

        sendErrorNotification() {
            this.$notify.addNotification({
                type: "error",
                title: 'Точка не найдена',
                description: 'Адрес в этой точке не найден. Возможно, точка расположена далеко от населенного пункта.',
                duration: 10000,
                position: 'bottom-right'
            })
        },

        sendSuccessNotification() {
            this.$notify.addNotification({
                type: "success",
                title: 'Точка найдена',
                description: 'Адрес в этой точке был найден.',
                duration: 10000,
                position: 'bottom-right'
            })
        },

        setActionBuffer(action, num){
            if(!this.isActionInBuffer(action, num)){
                this.actionBuffer.push(`${action}-${num}`)
            }
        },

        unsetActionBuffer(action, num) {
            this.actionBuffer = [...this.actionBuffer.filter(actionKey => actionKey !== `${action}-${num}`)]
        },

        isActionInBuffer(action, num){
            return this.actionBuffer.findIndex(actionKey => actionKey === `${action}-${num}`) !== -1
        }
    },
};
</script>

<style lang="scss">

.poi-modal {
    &__data {
        border: 1px solid #eaeced;
        border-radius: 10px;
        margin-bottom: 10px;
    }

    &__label {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 8px 15px;

        cursor: pointer;
    }

    &__data.active {
        .poi-modal__table {
            display: block;
        }
    }

    &__status {
        padding: 20px;
        margin-bottom: 10px;
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        border-radius: 15px;
        color: #131314;
        background: #edfae7;
    }

    &__table {
        display: none;
        overflow: auto;
        border-collapse: collapse;
        border-spacing: 0;

        & tr {
            border-radius: 4px;
        }

        & th,
        & td {
            padding: 10px;
            text-align: center;
            font-weight: 400;
            font-size: 12px;
            color: #46494e;
            border: 1px solid #d9e1e9;
        }

        & th {
            padding: 10px 30px;
            font-weight: 400;
            font-size: 12px;
            line-height: 14px;
            color: #747e8c;
            background: #eff3f6;
        }
    }

    &__body {
        display: flex;
        flex-direction: column;
        margin-bottom: 30px;
        min-height: max-content;
        background: #fff;
        border-radius: 10px;
        box-sizing: border-box;
    }

    &__preloader {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
    }

    &__header {
        margin-bottom: 20px;
        font-size: 20px;
        font-weight: 500;
        color: #000;

        @media (max-width: 576px) {
            font-size: 14px;
        }
    }

    &__row {
        margin-bottom: 20px;

        &:last-child {
            margin-bottom: 25px;
        }

        &._select {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
    }

    &__text {
        font-size: 12px;
        line-height: 16px;
        margin-bottom: 5px;
    }

    &__error {
        font-size: 12px;
        line-height: 16px;
        margin-bottom: 5px;
        color: #ff7c8e;
    }

    &__actions {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        button {
            margin-right: 10px;

            &:last-child {
                margin-right: 0;
            }
        }
    }

    &__cancel {
        color: #c8cad1;

        &:hover,
        &:active {
            color: #333;
        }
    }
}
</style>
